import { ActionLink } from '@cian/ui-kit';
import { IconActionChevronDownSmall16, IconActionChevronUpSmall16 } from '@cian/ui-kit-design-tokens/icons';
import React from 'react';

import * as styles from './ShowMoreButton.css';

interface IShowMoreButtonProps {
  onClick(): void;
  count: number;
  expanded: boolean;
}

export const ShowMoreButton: React.FC<IShowMoreButtonProps> = ({ onClick, count, expanded }) => {
  const text = expanded ? 'Свернуть' : `Посмотреть ещё ${count}`;
  const IconComponent = expanded ? IconActionChevronUpSmall16 : IconActionChevronDownSmall16;

  return (
    <li className={styles['show-more-button']}>
      <ActionLink
        fontSize="S"
        spacingSize="auto"
        afterIcon={<IconComponent color="icon-main-default" />}
        onClick={onClick}
      >
        {text}
      </ActionLink>
    </li>
  );
};
